import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-cta-share',
  imports: [
    UiModule,
    RouterModule
  ],
  templateUrl: './cta-share.html',
  styleUrl: './cta-share.css',
})
export class CtaShare {
  readonly router=inject(Router);
}
